export default __webpack_public_path__ + "static/media/1977.63bc08a3.jpg";